import axios from "axios";
import React, { Fragment, useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link, useLocation } from "react-router-dom";
import styled from "styled-components";
import { setAlert } from "../../../actions/alert";
import { updateLocation } from "../../../actions/currentLocation";
import { updateRestaurant } from "../../../actions/restaurantBuilder";
import { deleteRestaurant } from "../../../actions/restaurants";
import CheckUnauth from "../../auth/CheckUnauth";
import { slugify } from "../../../util/slugify";
import LocationPickerWidget from "../restaurantBuilder/restaurantBuilder2/shared/LocationPickerWidget";
import { LeftDiv } from "../restaurantBuilder/restaurantBuilderLegacy/RestaurantCreateBuild";
import PopupToggleWidget, {
  toggleRestaurant,
} from "../restaurantDetails/PopupToggleWidget";
import {
  CenteredContainer,
  CenteredContent,
} from "../restaurantDetails/RestaurantDetails";
import DeleteItem from "../restaurantResults/DeleteItem";
import { FlexRow } from "../../../styles/styled-components-utils";

export const PanelContainer = styled(FlexRow)`
  justify-content: flex-start;
  flex-wrap: nowrap;
  align-items: center;
  width: 100%;
  position: relative;
  gap: var(
    --spacing-md
  ); /* 12px spacing between all items using design token */
`;

export const Panel = styled.div`
  flex-shrink: 0;
`;

export const MainPanel = styled.div`
  flex: 1;
`;

export const Modal = styled.div`
  display: ${(props) => (props.show ? "block" : "none")};
  position: fixed;
  z-index: 1;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  background-color: rgb(0, 0, 0);
  background-color: rgba(0, 0, 0, 0.4);
`;

const ManagePopups = ({ token }) => {
  const location = useLocation();
  const [restaurants, setRestaurants] = useState([]);
  const [eventContext, setEventContext] = useState({}); // {eventId: {markers, overlay}}
  useEffect(function fetchOwnedRestaurantsOnMount() {
    async function getRestaurants() {
      setRestaurants(
        (await axios.get(`/api/restaurants/owned_restaurants`)).data
      );
    }
    getRestaurants();
  }, []);

  // Fetch event context (sibling restaurants + overlay) for each unique eventId
  useEffect(function fetchEventContextForRestaurants() {
    const eventIds = [...new Set(restaurants.filter(r => r.eventId).map(r => r.eventId))];
    eventIds.forEach(async (eventId) => {
      if (eventContext[eventId]) return;
      try {
        const [eventRes, restRes] = await Promise.all([
          axios.get(`/api/events/${eventId}`),
          axios.get(`/api/restaurants/query?eventId=${eventId}`),
        ]);
        const event = eventRes.data;
        const siblings = restRes.data;
        setEventContext((prev) => ({
          ...prev,
          [eventId]: {
            heading: event.heading || 0,
            markers: siblings
              .filter(r => r.geoJson?.coordinates)
              .map(r => ({
                lat: r.geoJson.coordinates[1],
                lng: r.geoJson.coordinates[0],
                name: r.name,
                id: r._id,
              })),
            overlay: event.mapOverlay?.imageUrl ? {
              imageUrl: event.mapOverlay.imageUrl,
              bounds: event.mapOverlay.bounds,
              opacity: event.mapOverlay.opacity,
            } : null,
          },
        }));
      } catch (err) {
        console.debug("Could not fetch event context:", err.message);
      }
    });
  }, [restaurants]); // eslint-disable-line react-hooks/exhaustive-deps

  const [show, setShow] = useState([]);
  useEffect(function resetModalsWhenRestaurantsChange() {
    setShow(new Array(restaurants.length).fill(false));
  }, [restaurants]);

  useEffect(function setupEscapeKeyListener() {
    function keyListener(e) {
      if (e.keyCode === 27) {
        setShow(new Array(restaurants.length).fill(false));
      }
    }

    document.addEventListener("keydown", keyListener);
    return () => document.removeEventListener("keydown", keyListener);
  }, [restaurants.length]);
  const [formData, setFormData] = useState({
    unsetGeoJson: { coordinates: [] },
  });
  const { unsetGeoJson } = formData;
  console.log(restaurants);
  return (
    <CenteredContainer className="container-full-width">
      <CenteredContent>
        <Fragment>
          <CheckUnauth {...location} />
          {restaurants.map((restaurant, i) => (
            <PanelContainer>
              <Fragment>
                <MainPanel> {restaurant.name} </MainPanel>
                {restaurant.status === "ONLINE" ||
                restaurant.status === "OFFLINE" ? (
                  <Fragment>
                    <Panel>
                      <PopupToggleWidget restaurant={restaurant} />
                    </Panel>
                    <Panel>
                      <i
                        className="fas fa-map-marked-alt fa-2x icon-primary"
                        onClick={() => {
                          setFormData((old) => ({
                            ...old,
                            unsetGeoJson: {
                              coordinates: restaurant.geoJson.coordinates,
                            },
                          }));
                          setShow((old) => [
                            ...old.slice(0, i),
                            true,
                            ...old.slice(i + 1),
                          ]);
                        }}
                      ></i>
                      <Modal show={show[i]}>
                        {show[i] && (
                          <div className="create-container margin-top-large">
                            <div className="form-container">
                              <div
                                className="closeButton"
                                onClick={() =>
                                  setShow((old) => [
                                    ...old.slice(0, i),
                                    false,
                                    ...old.slice(i + 1),
                                  ])
                                }
                              >
                                &times;
                              </div>
                              <LeftDiv>
                                <LocationPickerWidget
                                  name={restaurant.name}
                                  unsetGeoJson={unsetGeoJson}
                                  isDisabled={false}
                                  setFormData={setFormData}
                                  contextMarkers={
                                    restaurant.eventId && eventContext[restaurant.eventId]
                                      ? eventContext[restaurant.eventId].markers.filter(m => m.id !== restaurant._id)
                                      : undefined
                                  }
                                  overlayConfig={
                                    restaurant.eventId && eventContext[restaurant.eventId]
                                      ? eventContext[restaurant.eventId].overlay
                                      : undefined
                                  }
                                  heading={
                                    restaurant.eventId && eventContext[restaurant.eventId]
                                      ? eventContext[restaurant.eventId].heading
                                      : 0
                                  }
                                  submitCallback={async () => {
                                    try {
                                      const res = await axios.put(
                                        `/api/restaurants/popup/location/${restaurant._id}`,
                                        {
                                          lat: unsetGeoJson.coordinates[1],
                                          lng: unsetGeoJson.coordinates[0],
                                        }
                                      );
                                      // Update local state so reopening picker shows new position
                                      setRestaurants((prev) =>
                                        prev.map((r) =>
                                          r._id === restaurant._id ? res.data : r
                                        )
                                      );
                                    } catch (err) {
                                      console.error("Location update error:", err);
                                    }
                                    setShow((old) => [
                                      ...old.slice(0, i),
                                      false,
                                      ...old.slice(i + 1),
                                    ]);
                                  }}
                                  defaultZoom={18}
                                  submitButtonText="Update Location"
                                />
                              </LeftDiv>
                            </div>
                          </div>
                        )}
                      </Modal>
                    </Panel>
                  </Fragment>
                ) : null}

                <Panel>
                  <Link
                    to={{
                      pathname: `/details/${restaurant._id}/${slugify(restaurant.name)}`,
                      search: "?tab=edit-listing",
                    }}
                    className="link-no-decoration"
                  >
                    <i class="fas fa-pencil-alt"></i>
                  </Link>
                </Panel>
                <Panel>
                  <DeleteItem
                    id={restaurant._id}
                    deleteFunction={deleteRestaurant}
                  />
                </Panel>
              </Fragment>
            </PanelContainer>
          ))}
        </Fragment>
      </CenteredContent>
    </CenteredContainer>
  );
};

export default connect((state) => {}, {
  updateRestaurant,
  updateLocation,
  setAlert,
})(ManagePopups);
